import { IMapContainer } from "../../map/types"
import { classes } from "../react"

interface Props {
    map: IMapContainer
}

export const MapViewTools: React.FunctionComponent<Props> = ({ map }) => {

    const mm = map.getMeasuringTool()

    const [state, setState] = React.useState({
        showToolsPopup: mm.isActive()
    })

    React.useEffect(() => () => {
        if (mm) {
            mm.setActive(false)
        }
    }, [])

    const { showToolsPopup } = state

    const setActive = (active: boolean) => {
        mm.setActive(active)
        setState({ ...state, showToolsPopup: active })
    }

    const run = (action: () => void) => {
        action()
        setState({ ...state })
    }

    return <div className={classes({ tools: true, open: showToolsPopup, closed: !showToolsPopup })}>

        {
            (!showToolsPopup) &&
            <div className="switch" onClick={() => setActive(true)}>
                <i className="icon icon-option-vertical"></i>
            </div>
        }

        {
            showToolsPopup &&
            <div className="body">

                <div className="cmd">

                    <div className="btn-group">
                        <button type="button" className="btn btn-link" onClick={() => run(() => mm.startMeasuringLength())}
                            disabled={mm.isDrawingNewMeasure()}>
                            Measure length
                        </button>
                    </div>

                    <div className="btn-group">
                        <button type="button" className="btn btn-link" onClick={() => run(() => mm.startMeasuringArea())}
                            disabled={mm.isDrawingNewMeasure()}>
                            Measure area
                        </button>
                    </div>

                    <div className="btn-group">
                        <button type="button" className="btn btn-link" disabled={!mm.hasMeasures()}
                            onClick={() => run(() => mm.clearMeasures())}>
                            <i className="icon icon-erase"></i>
                            Clear
                        </button>
                    </div>

                </div>

                <div className="buttons">

                    <div className="btn-group">
                        <button type="button" className="btn btn-link btn-sm" onClick={() => setActive(false)}>
                            <i className="icon icon-close-simple"></i>
                            Close
                        </button>
                    </div>

                </div>


            </div>
        }

    </div>
}

